type ActiveRefParams = {
  active: HTMLElement;
  scroller: HTMLElement;
  placeholder: HTMLElement;
  close: HTMLElement;
};
const obj: {
  destroyAd: (type: string) => void;
  activeRef: ActiveRefParams;
} = {
  destroyAd: (_type) => {},
  activeRef: {} as ActiveRefParams,
};
export default obj;
